module.exports = __webpack_public_path__ + "static/media/videoIcon.c401dab1.svg";